import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  FilterBySearchTextAction,
  LearningObjectivesState,
} from "../shared/store/learning-objectives.state";
import { ILearningObjectiveFilters } from "./../shared/model/interfaces";
import { LearningObjective } from "./../shared/model/model";

import { LearningObjectiveFiltersComponent } from "../shared/components/learning-objective-filters.component";

@Component({
  selector: "app-filters",
  standalone: true,
  imports: [CommonModule, LearningObjectiveFiltersComponent, AsyncPipe],
  template: `<ng-container *ngIf="filterState$ | async as filterState">
    <app-learning-objective-filters
      [placeholdertext]="placeholdertext"
      [disabled]="disabled"
      [canToggleRelatedOnly]="selectedLearningObjective$ | async"
      (filterText)="filterText($event)"
    >
    </app-learning-objective-filters>
  </ng-container>`,
})
export class FilterComponent {
  @Input() disabled = false;
  @Input() placeholdertext: string;

  filterState$: Observable<ILearningObjectiveFilters>;
  selectedLearningObjective$: Observable<LearningObjective>;
  constructor(private store: Store) {
    this.filterState$ = store.select(LearningObjectivesState.filters);
    this.selectedLearningObjective$ = store
      .select(LearningObjectivesState.selectedLearningObjective)
      .pipe(map((s) => s.ref));
  }
  filterText = (text: string) =>
    this.store.dispatch(new FilterBySearchTextAction(text));
}
